module.exports = __webpack_public_path__ + "static/img/mxzy1.cc0bfff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/mxzy1.png
// module id = wT5p
// module chunks = 0